function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import App from 'modules/App';
import messages from '../../messages';
import styles from './ErrorLayout.pcss';
var _React_Component;
class ErrorLayout extends (_React_Component = React.Component) {
    render() {
        const titleMessage = this.props.metaTitleMessage ? this.props.metaTitleMessage : _object_spread({}, messages.meta.title);
        const descriptionMessage = this.props.metaDescriptionMessage ? this.props.metaDescriptionMessage : _object_spread({}, messages.meta.description);
        return /*#__PURE__*/ _jsx(App.components.LanguageProvider, {
            children: /*#__PURE__*/ _jsxs("div", {
                className: cn(styles.root, 'no-gutters'),
                children: [
                    /*#__PURE__*/ _jsx(App.components.IntlHelmet, {
                        titleMessage: titleMessage,
                        descriptionMessage: descriptionMessage
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-auto d-lg-none",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: styles.logoBar,
                            children: /*#__PURE__*/ _jsx("img", {
                                src: "/bo/assets/svg/logo.svg",
                                className: styles.logoBar__logo,
                                alt: "Ascensia Diabetes Care"
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: cn('col', styles.container),
                        children: /*#__PURE__*/ _jsx("div", {
                            className: styles.containerInner,
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "content content--fixed",
                                children: this.props.children
                            })
                        })
                    })
                ]
            })
        });
    }
}
_define_property(ErrorLayout, "propTypes", {
    // Explicit props
    children: PropTypes.node,
    metaTitleMessage: PropTypes.object,
    metaDescriptionMessage: PropTypes.object
});
export default withStyles(styles)(ErrorLayout);
